module.exports = __webpack_public_path__ + "img/Notifications-light.62ca7712.svg";